export class AddressDto {
    public id: number | undefined = undefined;    
    public street: string | undefined = undefined;
    public zipCode: string | undefined = undefined;
    public town: string | undefined = undefined;
}